interface JobCardProps {
  job: any;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onToggleStatus: (id: number) => void;
}

const typeLabels: Record<string, string> = { 'full-time': 'משרה מלאה', 'part-time': 'משרה חלקית', 'freelance': 'פרילנס' };
const typeColors: Record<string, string> = { 'full-time': 'bg-violet-50 text-violet-600 border-violet-200', 'part-time': 'bg-amber-50 text-amber-600 border-amber-200', 'freelance': 'bg-emerald-50 text-emerald-600 border-emerald-200' };

export default function JobCard({ job, onEdit, onDelete, onToggleStatus }: JobCardProps) {
  const isOpen = job.status === 'open';

  return (
    <div className="bg-white rounded-2xl border-2 border-rose-100 p-5 hover:border-rose-200 transition-all duration-200 hover:scale-[1.01]">
      <div className="flex items-start gap-3 mb-3">
        <div className="w-11 h-11 flex items-center justify-center rounded-xl border-2 border-rose-100 bg-rose-50 overflow-hidden flex-shrink-0">
          {job.company_logo ? <img src={job.company_logo} alt={job.company} className="w-full h-full object-contain p-1" /> : (
            <span className="text-sm font-bold text-rose-400">{job.company?.charAt(0) || '?'}</span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-bold text-gray-800 text-sm leading-snug">{job.title}</h3>
          <p className="text-xs text-gray-500 mt-0.5">{job.company}</p>
        </div>
        <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border-2 flex-shrink-0 whitespace-nowrap ${isOpen ? 'bg-emerald-50 text-emerald-600 border-emerald-200' : 'bg-gray-100 text-gray-500 border-gray-200'}`}>
          {isOpen ? 'פתוח' : 'סגור'}
        </span>
      </div>
      <div className="flex flex-wrap gap-2 mb-3">
        <span className={`text-xs font-medium px-2.5 py-1 rounded-full border ${typeColors[job.type]}`}>{typeLabels[job.type]}</span>
        <span className="flex items-center gap-1 text-xs text-gray-500"><i className="ri-map-pin-line"></i>{job.location}</span>
      </div>
      <p className="text-xs text-gray-500 mb-3 line-clamp-2 leading-relaxed">{job.description}</p>
      <div className="flex flex-wrap gap-1.5 mb-4">
        {(job.requirements || []).slice(0, 3).map((req: string) => (
          <span key={req} className="text-xs px-2 py-0.5 rounded-full bg-rose-50 text-rose-500 border border-rose-100">{req}</span>
        ))}
        {job.requirements?.length > 3 && <span className="text-xs px-2 py-0.5 rounded-full bg-gray-50 text-gray-400 border border-gray-100">+{job.requirements.length - 3}</span>}
      </div>
      <div className="flex items-center justify-between pt-3 border-t-2 border-rose-50">
        <button onClick={() => onToggleStatus(job.id)}
          className={`px-3 py-1.5 rounded-xl text-xs font-semibold border-2 transition-all cursor-pointer ${isOpen ? 'bg-emerald-50 text-emerald-600 border-emerald-200 hover:bg-emerald-100' : 'bg-gray-50 text-gray-400 border-gray-200 hover:bg-gray-100'}`}>
          {isOpen ? 'סגור משרה' : 'פתח משרה'}
        </button>
        <div className="flex gap-2">
          <button onClick={() => onEdit(job.id)} className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-xl border-2 border-rose-200 bg-rose-50 text-rose-500 text-xs font-semibold hover:bg-rose-100 transition-all cursor-pointer whitespace-nowrap">
            <div className="w-3 h-3 flex items-center justify-center"><i className="ri-edit-line text-xs"></i></div>עריכה
          </button>
          {!job.is_protected && (
            <button onClick={() => onDelete(job.id)} className="w-8 h-8 flex items-center justify-center rounded-xl border-2 border-gray-200 bg-gray-50 text-gray-400 hover:bg-red-50 hover:border-red-200 hover:text-red-400 transition-all cursor-pointer">
              <i className="ri-delete-bin-line text-sm"></i>
            </button>
          )}
          {job.is_protected && (
            <div className="flex items-center justify-center px-2 py-1.5 rounded-xl border-2 border-amber-200 bg-amber-50 text-amber-500 text-xs font-semibold whitespace-nowrap">
              <i className="ri-lock-line ml-1"></i>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
